// Slice 40 — Vyvern nested-V logo. Shared with @vyvern/ui (operator panel)
// at the *concept* level (same mark), but rendered here as a self-contained
// component so the HQ SPA has no @vyvern/ui import — the spec's "own design
// system" rule means HQ ships independent of the operator panel's library.
//
// `color` defaults to `currentColor` so wherever the logo lands it inherits
// the surrounding accent (cyan in the sidebar header, white in flag-banners).

import type { CSSProperties } from "react";

export interface LogoProps {
  size?: number;
  color?: string;
  ariaLabel?: string;
  style?: CSSProperties;
}

export function Logo({ size = 22, color, ariaLabel = "Vyvern", style }: LogoProps) {
  const c = color ?? "var(--hq-accent)";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", ...style }}>
      <svg
        viewBox="0 0 32 32"
        width={size}
        height={size}
        fill="none"
        role="img"
        aria-label={ariaLabel}
      >
        <title>{ariaLabel}</title>
        <path
          d="M2 6 L16 30 L30 6"
          stroke={c}
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity=".45"
        />
        <path
          d="M7 6 L16 22 L25 6"
          stroke={c}
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity=".72"
        />
        <path
          d="M12 6 L16 14 L20 6"
          stroke={c}
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
